<template>
    <div class="story-maker-sticker story-maker-sticker-mention" :class="{edit : isSelected,  hide: stickerInstance.data.isHide}" @click="finish">
        <!-- <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')"> -->
        <!-- <p class="text-finish" @click="finish">Terminé</p> -->
        <template v-if="isSelected">
            <i v-if="isHide" class="fa-solid fa-eye" @click="toggleHide"></i>
            <i v-else class="fa-solid fa-eye-slash" @click="toggleHide"></i>
        </template>
      
        <div 
            @click="stickerInstance.nextStyleVariant"
            class="sticker sticker-mention" 
            :class="{
                [`style${stickerInstance.data.styleVariant}`]:true,  
            }"
        >
           <div class="icon"></div>
            <p
                :contenteditable="isSelected"
                @input="handlerInput"
                ref="mentionInput"
                v-html="models.mention"
                class="textarea"
            ></p>
        </div>

        <div class="mentions hide-scrollbar" @wheel="handleHorizontalScroll">
            <div v-if="stateLoader && models.mention.length" class="mention-loader">
                <span class="loader"></span>
            </div>
            <template v-else>
                <div
                    class="mention"
                    :class="{ selected: stickerInstance.data.mention && stickerInstance.data.mention.id === m.id }"
                    v-for="m in mentions"
                    :key="m.id"
                    @click.stop="selectMention(m)"
                >
                    <img :src="m.image ? m.image : 'img/avatar.jpg'" alt="">
                    <p>{{m.id}}</p>
                    <i v-if="stickerInstance.data.mention && stickerInstance.data.mention.id === m.id" class="fa-solid fa-circle-check mention-check"></i>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import store from '@/store/index.js'
import { EventBus } from '@/event-bus';
import minxinBots from '@/components/mixins/Bots.vue'   

export default {
    mixins: [minxinBots],

    props: {
        id: [Number, String],
        isSelected: Boolean,

        stickerInstance: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            models: {
                mention: ''
            },
            cursorPosition: null,
            timeoutInitSearch: null,
            stateLoader: true,
           
            mentions:[],
        };
    },

    mounted () {
        if (this.stickerInstance.data.mention) {
            this.$set(this.models, 'mention', this.stickerInstance.data.mention.id);
        }

        if (this.isSelected) {
            this.focusAtEnd(this.$refs[`mentionInput`]);
            if (this.mention && this.mention.id) this.searchPerson();
        }
    },

    methods: {
        finish(event, mention = null) {
            if (this.isSelected && event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish') || event.target.classList.contains('mention-event')) {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch);
                this.$emit('unselect')
                if (!this.stickerInstance.data.mention) {
                     this.$emit('deleteSticker')
                     return
                }

                this.models.mention = this.stickerInstance.data.mention.id;
                this.mentions = [];
            }
        },

        async searchPerson() {

            if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
            this.stateLoader = true
            this.timeoutInitSearch = setTimeout(async () => {
                let page = this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                if (page) {
                    this.stateLoader = true
                    this.mentions =  (await this.getMentionsByApi(page.id, this.$refs[`mentionInput`].innerText, false, true)).mentions

                    const typedUsername = this.$refs[`mentionInput`].innerText.trim().toLowerCase();
                    const indexExactMatch = this.mentions.findIndex(m => m.id && m.id.toLowerCase() === typedUsername);
                    
                    if (indexExactMatch !== -1) {
                        const mention = this.mentions[indexExactMatch];
                        this.selectMention(mention);
                        this.mentions = [mention, ...this.mentions.filter((_, i) => i !== indexExactMatch)];
                    } 
                    this.stateLoader = false
                  
                }
            },1000)
           
        },

        toggleHide(e) {
            this.stickerInstance.data.isHide = !this.stickerInstance.data.isHide
        },

        handlerInput(e) {
            this.updateCursorPosition()
            this.models.mention = e.target.innerHTML
            const noSpaces = e.target.innerHTML.replaceAll(' ', '')
            const newTextMention = noSpaces.toLowerCase()
            
            this.$nextTick(() => {
                if (e.target.innerHTML !== newTextMention) {
                    this.models.mention = newTextMention
                    if (e.target.innerHTML !== noSpaces) {
                        this.cursorPosition = this.cursorPosition > 0 ? this.cursorPosition - 1 : 0
                    }
                    this.$nextTick(() => {
                        this.restoreCursorPosition()
                        this.searchPerson()
                    })
                } else {
                    this.restoreCursorPosition()
                    this.searchPerson()
                }
            })

           
        },

        focusAtEnd(element) {
            if (!element || !element.isContentEditable) return;

            const range = document.createRange();
            const selection = window.getSelection();

            range.selectNodeContents(element);
            range.collapse(false);

            selection.removeAllRanges();
            selection.addRange(range);

            // Donnez le focus à l'élément
            element.focus();
        },
       
        updateCursorPosition() {
           const selection = window.getSelection();
           if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                let nodeIndex = 0
                if (this.cursorPosition !== range.startOffset) {
                    this.cursorPosition = range.startOffset
                }
           }
       },
       
        restoreCursorPosition() {
            this.$refs[`mentionInput`].focus();
            let node = this.$refs[`mentionInput`].childNodes[0]
            const selection = window.getSelection();
            selection.removeAllRanges();
            const range = document.createRange();
            range.setStart(node, this.cursorPosition);
            range.collapse(true);
            selection.addRange(range);
        },

        selectMention(mention) {
            this.stickerInstance.data.mention = mention;
            this.$set(this.models, 'mention', mention.id);
            this.$nextTick(() => { this.focusAtEnd(this.$refs['mentionInput']); });
        },

        handleHorizontalScroll(event) {
            if (event.deltaX == 0) {
                event.preventDefault();
                const scrollContainer = event.currentTarget;
                scrollContainer.scrollLeft += event.deltaY;
            }
        }      
    },

    watch: {
        ['stickerInstance.data.mention']: {
            handler(newMention) {
                if (newMention) {
                    this.$set(this.models,'mention', newMention.id)
                }
            },
            immediate: true
        },

        isSelected: {
            handler(newValue) {
                if (newValue) {
                    this.focusAtEnd(this.$refs[`mentionInput`]);
                    if (this.models.mention) this.searchPerson();
                }
            },
            immediate: true
        },
    },


    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
        },
    },
};
</script>
